/**
 * Auth object represents authentication-related API endpoints and their methods.
 */
const Auth = {
  /**
   * Endpoint for admin login.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for admin login.
   * @property {string} method - The HTTP method for admin login (POST).
   */

  accountLogin: {
    url: "/auth/login",
    method: "POST",
  },

  /**
   * Endpoint for changing admin password.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for changing admin password.
   * @property {string} method - The HTTP method for changing admin password (PATCH).
   */
  changePassword: {
    url: "/admin/change-password",
    method: "PATCH",
  },

  /**
   * Endpoint for admin password recovery.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for admin password recovery.
   * @property {string} method - The HTTP method for admin password recovery (PATCH).
   */
  accountForgot: {
    url: "/admin/forgot-password",
    method: "POST",
  },

  /**
   * Endpoint for resetting admin password.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for resetting admin password.
   * @property {string} method - The HTTP method for resetting admin password (PATCH).
   */
  resetPassword: {
    url: "/admin/reset-password",
    method: "PATCH",
  },

  /**
   * Endpoint for updating admin account information.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for updating admin account information.
   * @property {string} method - The HTTP method for updating admin account information (PUT).
   */
  accountUpdate: {
    url: "/admin/update-profile",
    method: "PATCH",
  },

  /**
   * Endpoint for updating admin profile image.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for updating admin profile image.
   * @property {string} method - The HTTP method for updating admin profile image (PATCH).
   */
  updateProfileImage: {
    url: "/admin/update-profile",
    method: "PATCH",
  },

  /**
   * Endpoint for admin logout.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for admin logout.
   * @property {string} method - The HTTP method for admin logout (POST).
   */
  accountLogout: {
    url: "/auth/logout",
    method: "GET",
  },
  /**
   * Endpoint for admin auth detail.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for admin auth detail.
   * @property {string} method - The HTTP method for admin logout (GET).
   */
  getAdminDetails: {
    url: "/auth/me",
    method: "GET",
  },
};

// Export the Auth object for use in other modules
export default Auth;
